import React, { useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { toast } from 'sonner';
import { Loader2, PartyPopper } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;

export default function WaitlistDialog({ open, onOpenChange, defaultEmail = "" }) {
    const [email, setEmail] = useState(defaultEmail);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            // This assumes you added the /waitlist route to server.py!
            await axios.post(`${API}/waitlist`, { email });
            setSuccess(true);
            toast.success("You're on the list!");
        } catch (error) {
            toast.error("Failed to join waitlist. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        onOpenChange(false);
        setTimeout(() => setSuccess(false), 300); // Reset for next time
    };

    return (
        <Dialog open={open} onOpenChange={handleClose}>
            <DialogContent className="sm:max-w-[425px]">
                {!success ? (
                    <>
                        <DialogHeader>
                            <DialogTitle>SubHack Pro is Coming Soon</DialogTitle>
                            <DialogDescription>
                                We are finalizing our payment processor. Join the waitlist to get 
                                <strong> Early Founder Pricing</strong> the moment we go live.
                            </DialogDescription>
                        </DialogHeader>
                        <form onSubmit={handleSubmit} className="grid gap-4 py-4">
                            <div className="grid gap-2">
                                <Label htmlFor="waitlist-email">Email address</Label>
                                <Input
                                    id="waitlist-email"
                                    type="email"
                                    placeholder="you@example.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <DialogFooter>
                                <Button type="submit" className="w-full btn-primary" disabled={loading}>
                                    {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : 'Notify Me'}
                                </Button>
                            </DialogFooter>
                        </form>
                    </>
                ) : (
                    <div className="flex flex-col items-center justify-center py-6 text-center animate-in fade-in zoom-in duration-300">
                        <div className="w-12 h-12 bg-primary/20 rounded-full flex items-center justify-center mb-4">
                            <PartyPopper className="w-6 h-6 text-primary" />
                        </div>
                        <h3 className="font-heading text-xl mb-2">You're In!</h3>
                        <p className="text-muted-foreground text-sm mb-6">
                            We've secured your spot. Watch your inbox.
                        </p>
                        <Button onClick={handleClose} variant="outline" className="min-w-[120px]">
                            Close
                        </Button>
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
}